import { Injectable } from '@angular/core';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import { Observable } from 'rxjs';
import { Dictionary } from '@common_libraries/helpers/Dictionary';
import {PwdResetReturn} from '@login/components/VerifyPasswordReset/model/verifypasswordreset.component.model';
import {GetHelpLinkModel} from '@services/user/user.service.model';
import {map} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class UserService {

  public constructor(private servLib: ServiceLibrary ) { }

  GetCompaniesForUser() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/User/GetCompaniesForUser', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetTopCompanyForUser() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/User/GetTopCompanyForUser', ServiceLibrary.ContentType.JSON, parameters);
  }

  getCurrentUser(): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/User/GetCurrentUser', ServiceLibrary.ContentType.JSON, parameters);
  }

  ResetPassword(username: string) {
    const parameters = new Dictionary([]);
    parameters.add('userName', username);

    return this.servLib.HttpPost('/v1/api/User/ResetPassword', ServiceLibrary.ContentType.JSON, parameters, null,  false);
  }

  Logout() {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/logout', ServiceLibrary.ContentType.TEXT, parameters);
  }

  GetUserSecurityActivity(days) {
    const parameters = new Dictionary([]);
    parameters.add('days', days);
    return this.servLib.HttpPost('/v1/api/User/GetUserSecurityActivity', ServiceLibrary.ContentType.JSON, parameters);
  }

  ValidateResetPasswordCode(code: string): Observable<PwdResetReturn> {
    const parameters = new Dictionary([]);
    parameters.add('code', code);
    parameters.add('pwd', '');
    return this.servLib.HttpPost('/v1/api/User/ValidateResetPasswordCode', ServiceLibrary.ContentType.JSON, parameters, null, false)
      .pipe(map((res: any) => res.json.data));
  }

  VerifyResetPassword(code: string, pwd: string): Observable<PwdResetReturn> {
    const parameters = new Dictionary([]);
    parameters.add('code', code);
    parameters.add('pwd', pwd);
    return this.servLib.HttpPost('/v1/api/User/VerifyResetPassword', ServiceLibrary.ContentType.JSON, parameters, null, false)
      .pipe(map((res: any) => res.json.data));
  }

  AcceptTermsOfUse(termsVersion: number) {
    const parameters = new Dictionary([]);
    parameters.add('termsVersion', termsVersion);
    return this.servLib.HttpPost('/v1/api/User/AcceptTermsOfUse', ServiceLibrary.ContentType.JSON, parameters);
  }

  AcceptTermsOfUseGet() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/User/TermsOfUse', ServiceLibrary.ContentType.JSON, parameters );
  }

  AcceptTermsOfUseGetByLogin(login: string) {
    const parameters = new Dictionary([]);
    parameters.add('Email', login);
    return this.servLib.HttpPost('/v1/api/User/TermsOfUseByLogin', ServiceLibrary.ContentType.JSON, parameters, null, false);
  }

  GetHelpLink(): Observable<GetHelpLinkModel> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/User/HelpLink', ServiceLibrary.ContentType.JSON, parameters)
      .pipe(map((res: any) => res.json.data));
  }

  SystemLink(login: string) {
    const parameters = new Dictionary([]);
    parameters.add('Email', login);
    return this.servLib.HttpPost('/v1/api/User/SystemLink', ServiceLibrary.ContentType.JSON, parameters, null, false);
  }

  CheckForHalts(email: string) {
    const parameters = new Dictionary([]);
    parameters.add('Email', email);
    return this.servLib.HttpPost('/v1/api/User/CheckForHalts', ServiceLibrary.ContentType.JSON, parameters, null, false);
  }
}

